import { ACTIVITY_LOG_TYPE } from "./logs";
import { KEYLOCKER_COMMUNICATION_EVENT_TYPE } from "../../../../../util/communication_statuses";
import { ROLES } from "../../../../../util/common";

export const getName = event => {
  if (!event) return "";
  if (event.user) return `${event.user.first_name || ""} ${event.user.last_name || ""}`.trim();
  if (event.receivers?.length) return event.receivers[0].destination || "";

  return "";
};

const getKeylockerCommEventNote = (event, t) => {
  const boxNumber = String(event.keylocker_box_number ?? "");
  const keylockerName = String(event.keylocker_name ?? "");

  if (event.type === KEYLOCKER_COMMUNICATION_EVENT_TYPE.CHECK_IN_ANSWERED)
    return (
      t("cc_key_dropped_in_box_BoxNumber_of_KeylockerName", { boxNumber, keylockerName }).message || "Key dropped in box {{keylocker_box_number}} of {{keylocker_name}}"
    );

  if (event.type === KEYLOCKER_COMMUNICATION_EVENT_TYPE.PICK_UP_PIN_SENT)
    return (
      t("cc_pick_up_pin_sent_for_box_BoxNumber_of_KeylockerName", {
        boxNumber,
        keylockerName,
      }).message || "Pick up pin sent for box {{keylocker_box_number}} of {{keylocker_name}}"
    );

  return null;
};

export const getKeylockerNonEventActivityTitle = (t, roleId, isCustomer) => {
  if (isCustomer) return t("cc_keylocker_open_by_customer").message || "Keylocker open by customer";

  switch (roleId) {
    case ROLES.MECHANIC:
      return t("cc_keylocker_open_by_mechanic").message || "Keylocker open by mechanic";
    case ROLES.RECEPTIONIST:
      return t("cc_keylocker_open_by_receptionist").message || "Keylocker open by receptionist";
    default:
      return "";
  }
};

export const getKeylockerCommEventLogs = (appointment, event, t) => {
  const { key_picked_up_by, key_dropped_back_at, key_picked_up_at, key_picked_up_back_at, key_picked_up_back_by, key_dropped_back_by } = appointment;

  const tableData = [];

  tableData.push({
    time: event.created_on,
    activityType: ACTIVITY_LOG_TYPE.KEYLOCKER,
    name: getName(event),
    note: getKeylockerCommEventNote(event, t),
    eventType: event.type,
    keylockerPinRequestType: event.pin_request_type ?? undefined,
  });

  if (event.type === KEYLOCKER_COMMUNICATION_EVENT_TYPE.CHECK_IN_ANSWERED && key_picked_up_at) {
    tableData.push({
      time: key_picked_up_at,
      activityType: ACTIVITY_LOG_TYPE.KEYLOCKER,
      note: t("cc_key_picked_up").message || "Key picked up",
      name: key_picked_up_by ? `${key_picked_up_by.first_name || ""} ${key_picked_up_by.last_name || ""}`.trim() : "",
      activityTitle: getKeylockerNonEventActivityTitle(t, key_picked_up_by?.role_id),
    });
  } else if (event.type === KEYLOCKER_COMMUNICATION_EVENT_TYPE.PICK_UP_PIN_SENT) {
    if (key_dropped_back_at) {
      tableData.push({
        time: key_dropped_back_at,
        activityType: ACTIVITY_LOG_TYPE.KEYLOCKER,
        note: t("cc_keylocker_key_dropped_back").message || "Key dropped back",
        name: key_dropped_back_by ? `${key_dropped_back_by.first_name || ""} ${key_dropped_back_by.last_name || ""}`.trim() : "",
        activityTitle: getKeylockerNonEventActivityTitle(t, key_dropped_back_by?.role_id),
      });
    }

    if (key_picked_up_back_at) {
      let name = "";
      let activityTitle = "";

      if (!key_picked_up_back_by) {
        const keylockerOpenedByCustomer = true;
        activityTitle = getKeylockerNonEventActivityTitle(t, null, keylockerOpenedByCustomer);
        name = getName(event);
      } else {
        name = `${key_picked_up_back_by.first_name || ""} ${key_picked_up_back_by.last_name || ""}`.trim();
        activityTitle = getKeylockerNonEventActivityTitle(t, key_picked_up_back_by.role_id);
      }

      tableData.push({
        time: key_picked_up_back_at,
        activityType: ACTIVITY_LOG_TYPE.KEYLOCKER,
        note: t("cc_key_picked_up_back").message || "Key picked up back",
        activityTitle,
        name,
      });
    }
  }

  return tableData;
};
